import React from 'react';
import styles from './PlainDivider.module.scss';;


const PlainDivider = () => <div className={styles.root} />;

export default PlainDivider;
